<div class="overflow-y-auto flex-1 min-h-0 p-2 flex flex-col gap-4">
  @for (item of menuItems; track item.routerLink; let i = $index) {
    <ul class="list-none m-0 flex flex-col gap-1">
      <li>
        <div
          class="flex items-center cursor-pointer p-3 gap-4 rounded-lg text-surface-0 hover:bg-surface-800 border border-transparent hover:border-surface-700 transition-colors duration-150"
          (click)="item.items?.length ? toggleMenu(item) : navigateTo(item)"
        >
          <i [class]="item.icon + ' text-xl'"></i>
          <span class="font-semibold text-base leading-tight">{{ item.label }}</span>
          @if (item.items?.length) {
            <i class="pi ml-auto text-sm" [ngClass]="isMenuExpanded(item) ? 'pi-chevron-up' : 'pi-chevron-down'"></i>
          }
        </div>
        @if (item.items?.length && isMenuExpanded(item)) {
          <ul class="list-none m-0 overflow-hidden flex flex-col gap-1 mt-1 ml-2">
            @for (subItem of item.items; track subItem.routerLink) {
              <li>
                <a
                  class="flex items-center cursor-pointer p-3 gap-2 rounded-lg text-surface-400 hover:bg-surface-800 border border-transparent hover:border-surface-700 transition-colors duration-150 hover:text-surface-0"
                  (click)="navigateTo(subItem)"
                >
                  <i [class]="subItem.icon + ' text-sm'"></i>
                  <span class="font-medium text-base leading-tight">{{ subItem.label }}</span>
                </a>
              </li>
            }
          </ul>
        }
      </li>
    </ul>

    <hr class="border-t border-surface-800 my-0">
  }
</div>

<!----

<div id="app-sidebar"
     class="h-full hidden lg:block flex-shrink-0 fixed lg:sticky left-0 top-0 z-1 border-right-1 surface-border w-full md:w-auto">
  <div class="flex h-full">
    <div class="flex flex-column h-full bg-indigo-900 flex-shrink-0 select-none">
      <div class="flex p-2 align-items-center justify-content-center flex-shrink-0" style="height:60px">
        <img src="assets/images/blocks/logos/hyper-light.svg" alt="Image" height="30">
      </div>
      <div class="overflow-y-auto mt-3 ">
        <ul class="list-none py-3 pl-2 pr-0 m-0">
          @for (item of menuItems; track item.routerLink; let i = $index) {
            <li class="mb-2" (click)="navigateTo(item)">
              <a pRipple
                 class="flex align-items-center cursor-pointer py-3 pl-2 pr-2 justify-content-center hover:bg-indigo-600 text-indigo-100 hover:text-indigo-50 transition-duration-150 transition-colors"
                 (click)="activeTab = i" [ngClass]="{'bg-indigo-500': activeTab === i}"
                 style="border-top-left-radius: 30px;border-bottom-left-radius: 30px;">
                <i [class]=" item.icon + ' text-xl'"></i>
              </a>
            </li>
          }
        </ul>
      </div>
    </div>
    <div class=" flex flex-column bg-indigo-500 p-4 overflow-y-auto flex-shrink-0 flex-grow-1 md:flex-grow-0"
         style="width:300px">
      <div class="justify-content-end mb-1 flex lg:hidden">
        <button icon="pi pi-times"
                class="cursor-pointer text-white appearance-none bg-transparent border-none inline-flex justify-content-center align-items-center border-circle hover:bg-indigo-600 transition-duration-150 transition-colors"
                style="width:2rem;height:2rem" pStyleClass="#app-sidebar" leaveToClass="hidden"
                leaveActiveClass="fadeoutleft">
          <i class="pi pi-times text-xl text-indigo-100"></i>
        </button>
      </div>
      <div class="border-round flex-auto">
        @for (item of menuItems; track item.routerLink; let i = $index) {
          <div [ngClass]="{'hidden': activeTab !== i}">
            <div class="pl-1 mb-2 font-medium text-lg text-white mb-1">{{ item.label }}</div>
            @for (subItem of item.items; track subItem.routerLink) {
              <div class="p-0 font-medium  text-white cursor-pointer" (click)="navigateTo(subItem)">
                <ul class="list-none p-0 m-0 text-white">
                  <li class="mb-3 flex align-items-start bg-indigo-700 p-3" style="border-radius: 12px">
                    <i class="pi pi-user text-xl mr-3 "></i>
                    <div class="flex flex-column">
                      <span class="text-md">{{ subItem.label }}</span>
                      <p class="mt-1 mb-0 line-height-3 text-indigo-200 text-sm">{{ subItem.description }}</p>
                    </div>
                  </li>
                </ul>
              </div>
            }
          </div>

        }

      </div>
      <div class="mt-auto border-top-1 border-white-alpha-10">
        <ul class="list-none p-2 m-0 hidden origin-bottom animation-duration-150 overflow-hidden animation-ease-in-out">
          <li>
            <a pRipple
               class="flex align-items-center cursor-pointer p-3 hover:bg-bluegray-700 text-gray-300 transition-duration-150 transition-colors"
               style="border-radius: 30px">
              <i class="pi pi-user mr-2"></i>
              <span class="font-medium">Profile</span>
            </a>
          </li>
          <li>
            <a pRipple
               (click)="signout()"
               class="flex align-items-center cursor-pointer p-3 hover:bg-bluegray-700 text-gray-300 transition-duration-150 transition-colors"
               style="border-radius: 30px">
              <i class="pi pi-sign-out mr-2"></i>
              <span class="font-medium">Sign Out</span>
            </a>
          </li>
        </ul>
        <a pRipple class="mt-3 px-3 py-0 flex align-items-center hover:bg-bluegray-700 text-gray-300 cursor-pointer text-gray-300
                    transition-duration-150 transition-colors"
           pStyleClass="@prev" enterClass="hidden" enterActiveClass="slidedown" leaveToClass="hidden"
           leaveActiveClass="slideup" style="border-radius: 30px">
          <img src="assets/images/blocks/avatars/circle/avatar-f-1.png" class="mr-2" style="width: 28px; height: 28px"/>
          <span class="font-medium">Jane Doe</span>
          <i class="pi pi-chevron-up ml-auto"></i>
        </a>
      </div>
    </div>

  </div>

</div>

-->
